module.exports = __webpack_public_path__ + "static/media/ic_add_white_18px.6cda6b69.svg";